var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 123,
    viewBox: "0 0 216 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 91H137C137.515 91 138.017 90.944 138.5 90.839C138.983 90.944 139.485 91 140 91H192C195.866 91 199 87.866 199 84C199 80.134 195.866 77 192 77H186C182.134 77 179 73.866 179 70C179 66.134 182.134 63 186 63H205C208.866 63 212 59.866 212 56C212 52.134 208.866 49 205 49H183C186.866 49 190 45.866 190 42C190 38.134 186.866 35 183 35H119C122.866 35 126 31.866 126 28C126 24.134 122.866 21 119 21H62C58.134 21 55 24.134 55 28C55 31.866 58.134 35 62 35H22C18.134 35 15 38.134 15 42C15 45.866 18.134 49 22 49H47C50.866 49 54 52.134 54 56C54 59.866 50.866 63 47 63H7C3.134 63 0 66.134 0 70C0 73.866 3.134 77 7 77H46C42.134 77 39 80.134 39 84C39 87.866 42.134 91 46 91ZM209 91C212.866 91 216 87.866 216 84C216 80.134 212.866 77 209 77C205.134 77 202 80.134 202 84C202 87.866 205.134 91 209 91Z",
    fill: "#F5FFFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.5 2V8",
    stroke: "#00B2A3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.5 16V22",
    stroke: "#00B2A3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M145.5 12H151.5",
    stroke: "#00B2A3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M159.5 12H165.5",
    stroke: "#00B2A3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 105V109",
    stroke: "#00B2A3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 117V121",
    stroke: "#00B2A3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 113H68.5",
    stroke: "#00B2A3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 113H80.5",
    stroke: "#00B2A3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.711 88.126C145.102 86.423 146.352 84.642 147.461 82.799C149.901 78.744 151.66 74.388 152.734 69.897C153.821 65.356 154.209 60.676 153.894 56.0296C153.62 51.9756 152.811 47.9475 151.465 44.0598C150.131 40.2028 148.268 36.484 145.875 33.015C144.45 30.9479 142.836 28.9696 141.034 27.1036C138.388 24.364 135.486 22.0219 132.402 20.0787C129.089 17.9908 125.566 16.3634 121.926 15.1984C117.368 13.7393 112.628 13.0054 107.886 13C104.197 12.9959 100.507 13.4328 96.902 14.3125C92.845 15.3028 88.895 16.8543 85.177 18.9692C81.9076 20.8284 78.817 23.123 75.988 25.8547C72.4328 29.2875 69.553 33.1572 67.3512 37.2985C65.1956 41.3531 63.6899 45.6682 62.8366 50.0887C61.9574 54.6429 61.7706 59.309 62.2789 63.918C62.9378 69.891 64.7643 75.768 67.7644 81.179C69.684 84.641 72.0842 87.912 74.9663 90.896C79.5416 95.634 84.883 99.183 90.604 101.535C97.562 104.397 105.081 105.489 112.465 104.8C118.662 104.221 124.765 102.387 130.361 99.29",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M143.711 88.126C145.102 86.423 146.352 84.642 147.461 82.799C149.901 78.744 151.66 74.388 152.734 69.897C153.821 65.356 154.209 60.676 153.894 56.0296C153.62 51.9756 152.811 47.9475 151.465 44.0598C150.131 40.2028 148.268 36.484 145.875 33.015C144.45 30.9479 142.836 28.9696 141.034 27.1036C138.388 24.364 135.486 22.0219 132.402 20.0787C129.089 17.9908 125.566 16.3634 121.926 15.1984C117.368 13.7393 112.628 13.0054 107.886 13C104.197 12.9959 100.507 13.4328 96.902 14.3125C92.845 15.3028 88.895 16.8543 85.177 18.9692C81.9076 20.8284 78.817 23.123 75.988 25.8547C72.4328 29.2875 69.553 33.1572 67.3512 37.2985C65.1956 41.3531 63.6899 45.6682 62.8366 50.0887C61.9574 54.6429 61.7706 59.309 62.2789 63.918C62.9378 69.891 64.7643 75.768 67.7644 81.179C69.684 84.641 72.0842 87.912 74.9663 90.896C79.5416 95.634 84.883 99.183 90.604 101.535C97.562 104.397 105.081 105.489 112.465 104.8C118.662 104.221 124.765 102.387 130.361 99.29",
    stroke: "#00B2A3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.701 97.378C136.607 95.508 139.191 93.175 140.872 91.291L133.701 97.378Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133.701 97.378C136.607 95.508 139.191 93.175 140.872 91.291",
    stroke: "#00B2A3",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M150 61.617C149.714 61.622 149.427 61.625 149.14 61.625C123.886 61.625 103.209 41.9362 101.476 17C81.3752 20.1706 66 37.6526 66 58.743C66 82.081 84.825 101 108.048 101C130.309 101 148.53 83.615 150 61.617Z",
    fill: "#DEF8F5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0229 57.373C90.7999 56.2433 88.9029 56.33 87.7849 57.567C86.6679 58.803 86.7529 60.721 87.9769 61.851L102.096 74.889C103.808 76.47 106.465 76.349 108.029 74.618C108.095 74.544 108.095 74.544 108.158 74.469L128.307 49.9716C129.366 48.6837 129.192 46.7716 127.918 45.7008C126.644 44.63 124.752 44.806 123.693 46.0939L104.75 69.125L92.0229 57.373Z",
    fill: "white",
    stroke: "#00B2A3",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.8239 21.4131C91.8739 22.1447 89.9689 23.0338 88.1279 24.0806C85.2689 25.7072 82.5647 27.7149 80.0898 30.1049C79.0753 31.0846 78.1236 32.105 77.2349 33.161M74.485 36.8378C73.7784 37.9057 73.128 39.0004 72.5341 40.1176C72.0955 40.9428 71.6876 41.7803 71.3105 42.6285",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M94.263 22.5832C94.909 22.3408 95.237 21.6202 94.994 20.9738C94.752 20.3275 94.031 20.0001 93.385 20.2426L94.263 22.5832ZM76.2786 32.356C75.8341 32.8842 75.902 33.6727 76.4302 34.1172C76.9584 34.5617 77.7469 34.4939 78.1914 33.9657L76.2786 32.356ZM75.5275 37.5275C75.9085 36.9517 75.7507 36.1762 75.1749 35.7952C74.5992 35.4142 73.8237 35.5721 73.4427 36.1478L75.5275 37.5275ZM70.1684 42.1204C69.8879 42.7513 70.1719 43.49 70.8027 43.7705C71.4335 44.0509 72.1723 43.7669 72.4528 43.1361L70.1684 42.1204ZM93.385 20.2426C91.373 20.9971 89.409 21.9141 87.51 22.9938L88.746 25.1669C90.529 24.153 92.374 23.2919 94.263 22.5832L93.385 20.2426ZM87.51 22.9938C84.56 24.6718 81.7724 26.7422 79.2216 29.2055L80.9582 31.0039C83.357 28.6872 85.977 26.7423 88.746 25.1669L87.51 22.9938ZM79.2216 29.2055C78.176 30.2152 77.195 31.2671 76.2786 32.356L78.1914 33.9657C79.0525 32.9425 79.9747 31.9536 80.9582 31.0039L79.2216 29.2055ZM73.4427 36.1478C72.7138 37.2492 72.0431 38.3783 71.4305 39.5307L73.638 40.7042C74.2132 39.622 74.8431 38.5618 75.5275 37.5275L73.4427 36.1478ZM71.4305 39.5307C70.978 40.3818 70.5573 41.2457 70.1684 42.1204L72.4528 43.1361C72.818 42.3146 73.2131 41.5034 73.638 40.7042L71.4305 39.5307Z",
    fill: "#00B2A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/SuccessIcon.a4db39d85f710b894527f890af45e8f6.svg";
export { ForwardRef as ReactComponent };